import { FC, useState } from "react"
import { LogModal } from "../LogModal/LogModal"
import { Button } from "@radix-ui/themes"

export const LogButton: FC<{
  getData: () => Promise<{ [key: string]: string }[]>
}> = ({ getData }) => {
  const [isOpenLogModal, setOpenLogModal] = useState(false)
  return (
    <>
      <Button onClick={() => setOpenLogModal(true)}>
        Посмотреть историю обновлений
      </Button>
      <LogModal
        isOpen={isOpenLogModal}
        onClose={() => setOpenLogModal(false)}
        getData={getData}
      />
    </>
  )
}
